module.exports = "https://static.zego.com/_next/static/images/trustpilot-star-rating-4_5-47e2b08aeea76d286f240cfc524781cc.svg";